<template>
  <div class="mine page">
    <div class="page-bg"></div>
    <div class="wrapper">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :loading-text="$t('加载中')" :pulling-text="$t('下拉即可刷新')"
        :loosing-text="$t('释放即可刷新')">
        <!-- <div style="height:42vw"></div> -->
        <div class="header" style="position: initial;">
          <van-nav-bar class="nav-bar">
            <template #right>
              <!-- <van-icon name="setting-o" @click="showSetting()" color="#fff"/> -->
                <a  @click="$router.push({ path: '/ServiceOnline' });" class="a-btn">
                  <img src="../../assets/image/xx.png" alt="">
                </a>
            </template>
          </van-nav-bar>
          <div class="user-wrapper" @click="doLogin()">
            <!-- <van-image round class="user_img" src="http://kongh5.haiwaiym18.top/img/avatar.b93a1df3.png">
               <template v-slot:loading>
                 <van-loading type="spinner"/>
               </template>
             </van-image> -->
            <van-image round class="user_img" :src="userInfo.header_img ? userInfo.header_img : '/img/image/mine.png'">
              <template v-slot:loading>
                <van-loading type="spinner" />
              </template>
            </van-image>
            <div class="login-content">
              <div class="login-btn">{{ this.userInfo.username }}</div>
              <div class="login-btn" style="font-size: 15px !important;">{{ this.$t('信誉分') }} <b>:</b> {{
                userInfo.credit_score }}
              </div>
            </div>
          </div>
        </div>
        <div class="content">

          <div style="width: 100%;position: absolute;left: 50%;transform: translateX(-50%);top:-40px;">
            <div class="wallet">
              <div class="part-1 van-hairline--bottom">
                <div class="flex-1 font-28 font-primary-color">{{ $t("my.activity_points") }}</div>
              </div>
              <div class="part-2">
                <div class="balance van-ellipsis"></div>
                <!-- <span class="font-28 font-gray">{{$t("my.balance")}}({{$t("reservation.unit")}})</span> -->
                <span class="font-28 font-gray">{{ $t("reservation.unit") }}</span>
                <div class="refresh-btn" @click="refresh()"><van-icon name="replay" /></div>
              </div>
              <div class="part-2 part-3">
                <p class="balance van-ellipsis">{{ this.userInfo.money }}</p>
                <!-- <span class="font-28 font-gray">{{$t("my.balance")}}({{$t("reservation.unit")}})</span> -->

              </div>
            </div>

            <div class="finance">
              <div class="finance-item finance-item2" @click="toService()">
                <img class="icon" src="../../assets/image/11.png" alt="">
                <span class="text">{{ $t("recharge.recharge") }}</span>
              </div>
              <div class="finance-item" @click="doWithdrawal()">
                <img class="icon" src="../../assets/image/qianbao.png" alt="">
                <span class="text">{{ $t("my.withdraw") }}</span>
              </div>


            </div>
          </div>
          <div style="height: 136px;width: 100%;background: #fff;"></div>
          <div style="width: 100%;height: 10px;background: #F2F2F5;"></div>
          <div class="menu">
            <div class="menu-item" @click="$router.push({ path: '/Infomation' });">
              <van-image class="menu-item-icon" src="/img/mine/jbxx.png">
                <template v-slot:loading>
                  <van-loading type="spinner" />
                </template>
              </van-image>
              <span class="menu-item-label">{{ $t("my.basic_information") }}</span>
              <i class="iconfont icon-youjiantou"></i>
            </div>
            <!-- <div class="menu-item" @click="$router.push({ path: '/MyCard' });">
                <van-image class="menu-item-icon" src="/img/mine/nav8.png">
                  <template v-slot:loading>
                    <van-loading type="spinner"/>
                  </template>
                </van-image>
                <span class="menu-item-label" >{{$t("my.my_balance")}}</span>
              </div> -->
            <div class="menu-item" @click="$router.push({ path: '/SetLoginPassword' });">
              <van-image class="menu-item-icon" src="/img/mine/22.png">
                <template v-slot:loading>
                  <van-loading type="spinner" />
                </template>
              </van-image>
              <span class="menu-item-label">{{ $t("my.Login_password") }}</span>
              <i class="iconfont icon-youjiantou"></i>
              <!-- <span class="menu-item-label" >{{$t("my.account_detail")}}</span> -->
            </div>

            <div class="menu-item" @click="$router.push({ path: '/GameRecord' });">
              <van-image class="menu-item-icon" src="/img/mine/66.png">
                <template v-slot:loading>
                  <van-loading type="spinner" />
                </template>
              </van-image>
              <span class="menu-item-label">{{ $t("my.task_log") }}</span>
              <i class="iconfont icon-youjiantou"></i>
            </div>
            <div class="menu-item" @click="toNotice()">
              <van-image class="menu-item-icon" src="/img/mine/33.png">
                <template v-slot:loading>
                  <van-loading type="spinner" />
                </template>
              </van-image>
              <span class="menu-item-label">{{ $t("my.sys_notice") }}</span>
              <i class="iconfont icon-youjiantou"></i>
            </div>
            <div class="menu-item" @click="toService">
              <van-image class="menu-item-icon" src="/img/mine/5.png">
                <template v-slot:loading>
                  <van-loading type="spinner" />
                </template>
              </van-image>
              <span class="menu-item-label">{{ $t("my.online_customer_service") }}</span>
              <i class="iconfont icon-youjiantou"></i>
            </div>

          </div>
          <div class="btn">
            <van-button color="linear-gradient(90deg,#6529c9,#cc2996)"
              style="margin: 20px 0;font-size: 16px;padding:25px 0;width: 100%;border-radius: 8px;"
              @click="loginout()">
              {{ $t("setting.logout") }}
            </van-button>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      userInfo: {
      },
      menu_top: 40,
      isLoading: false,
      timeOut: null
    };
  },
  methods: {
    refresh() {
      this.isLoading = true;
      this.getUserInfo(1);
    },
    exit() {
      this.$toast(this.$t("my.finish_task"));
    },
    showSetting() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/Setting' })
      } else {
        this.$router.push({ path: '/Login' })
      }
    },
    toNotice() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/Notice' })
      } else {
        this.$router.push({ path: '/Login' })
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem('token')) {
          this.getUserInfo();
          this.$toast(this.$t("reservation.refresh"));
        } else {
          this.$router.push({ path: '/Login' })
        }
      }, 500);
    },
    doLogin() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/Infomation' });
      } else {
        this.$router.push({ path: '/Login' })
      }
    },
    doPay() {
      this.$router.push({
        name: 'Recharge',
        params: {
          'balance': this.userInfo.money
        }
      })
    },
    doWithdrawal() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.data.is_bank) {
          this.$router.push("withdraw");
        } else {
          this.$router.push("Setbank");
          this.$toast.fail(this.$t("setting.set_bank"));
        }
      })
    },
    toService() {
      const service = this.$store.getters.getBaseInfo;
      console.log('service--->', service)
      if (service.iskefu == 1) {
        window.location.href = service.kefu
      }
    },
    getUserInfo(type) {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          if (type === 1) {
            this.isLoading = false;
            setTimeout(() => {
              this.$toast(this.$t("reservation.refresh"));
            }, 500)
          }
          this.$set(this, 'userInfo', res.data)
          this.menu_top = 15;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t("video.account_out"));
            localStorage.clear()
            this.$router.push({ path: '/Login' })
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
          localStorage.clear()
          setTimeout(() => {
            this.$router.push({ path: '/Login' })
          }, 1500)
        }
      })
    },
    loginout() {
      localStorage.clear()
      this.$router.push({ path: '/Login' });
    }
  },
  created() {
    if (localStorage.getItem('token')) {
      this.getUserInfo();
      this.timeOut = setInterval(() => {
        this.getUserInfo();
      }, 8000)
    } else {
      this.userInfo.username = this.$t("setting.log_reg");
      this.userInfo.ip = this.$t("setting.more_service");
      this.userInfo.header_img = "img/mine/avatar.png";
    }
  },
  beforeDestroy() {
    // 组件销毁前（离开页面时）销毁定时器
    clearInterval(this.timeOut)
    this.timeOut = null
  }
};
</script>

<style scoped lang="less">
.page {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  background-color: #f2f2f5;
}

.header,
.nav-bar {
  position: initial !important;
  position: relative;
  transform: initial;
}

.mine {
  position: relative;
  bottom: 20px;
  background: #f2f2f5;
  /* background: url('/img/usertop.660cec17.png') no-repeat top -16vw center; */
  /* background-size: contain; */
  padding-bottom: 7vw;
}

.mine .wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.nav-bar {
  /* background: linear-gradient(
      90deg,#7e5678,#e6c3a1); */
  background: content-box;
}

.mine .header {
  z-index: 1;
  padding-bottom: 100px;
  background-size: contain;
  background: #E45DBD;
  background: linear-gradient(135deg, rgba(228, 93, 189, 1) 0%, rgba(114, 73, 192, 1) 100%);
}

::v-deep .van-nav-bar__content {
  height: 100px;
}

::v-deep .van-hairline--bottom::after {
  border-bottom-width: 0px;
}

.mine .header .van-nav-bar .van-icon {
  font-size: 45px;
}

.mine .header .user-wrapper {
  display: flex;
  align-items: center;
  margin: 0px 40px 0px 40px;

}

.mine .user_img {
  height: 130px;
  width: 130px;
}

::v-deep .van-loading__spinner {
  height: 50px;
  width: 50px;
}

::v-deep .van-image__error-icon {
  font-size: 70px;
}

.mine .header .user-wrapper .login-content {
  flex: 1;
  margin-left: 30px;
  display: flex;
  flex-direction: column;
}

.mine .header .user-wrapper .login-content .login-btn {
  display: inline-block;
  font-size: 40px;
  color: #fff;
}

.mine .header .user-wrapper .login-content .login-label {
  margin-top: -13px;
  font-size: 28px;
  color: hsla(0, 0%, 100%, .6);
}

.mine .page-bg {
  height: 500px;

}

.mine .content {
  position: relative;
  height: fit-content;
  background: #fff;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #ffffff;
  font-size: 35px;
}

.mine .wrapper .content .finance {
  width: 90%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  height: 120px;
  border-radius: 15px;
  gap: 20px;
  z-index: 1;
  padding-bottom: 20px;
}

.mine .wrapper .content .finance .line {
  width: 3px;
  height: 40px;
  background-color: #ccc;
}

.mine .wrapper .content .finance .finance-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  overflow: hidden;
  height: 100%;
  background: #fff url('../../assets/image/yue.png') no-repeat center center / 100% 100%;

}

.mine .wrapper .content .finance .finance-item2 {
  background: #fff url('../../assets/image/1.png') no-repeat -140px center / 150%;
}

.mine .wrapper .content .finance .finance-item .text {
  margin-left: 30px;
  font-size: 30px;
  color: #ffffff;
  font-weight: 500;
}

.mine .wrapper .content .finance .finance-item .icon {
  font-size: 50px;
  display: block;
  width: auto;
  height: 40px;
}

.mine .wrapper .content .menu {
  display: flex;
  align-items: center;
  flex-direction: column;
  /* flex-wrap: wrap; */
  background-color: #fff;
  box-shadow: 0 1.5px 1px 0 #e4e4e7;
  box-sizing: border-box;
}

.mine .wrapper .content .menu .menu-item {
  display: flex;
  align-items: center;
  /* flex-direction: column; */
  width: 100%;
  height: 108px;
  padding: 0 30px 0px 10px;

  .iconfont {
    font-size: 26px;
    color: #432788;
    margin-left: auto;
  }
}

.mine .wrapper .content .menu .menu-item .menu-item-label {
  font-size: 28px;
  color: #432788;
  font-weight: 500;
  text-align: center;
}

.mine .wrapper .content .menu .menu-item .menu-item-icon {
  margin: 25px;
  width: 60px;
  height: 60px;
  -o-object-fit: contain;
  object-fit: contain;
}

.mine .wrapper .content .wallet {
  width: 90%;
  /* margin-top: 80px; */
  padding: 0 20px 5px 30px;
  background: url('../../assets/image/yue.png') no-repeat center center / 105% 105%;
  border-radius: 20px;
  box-shadow: 0 1.5px 1px 0 #e4e4e7;
  margin: 0px auto 20px auto;
}

.mine .wrapper .content .wallet .part-1 {
  display: flex;
  align-items: center;
  height: 100px;
}

.mine .wrapper .content .wallet .font-primary-color {
  color: #fff;
  font-size: 32px;
}

.font-gray {
  color: #fff;
  font-size: 28px;
}

.mine .wrapper .content .wallet .part-2 {
  display: flex;
  align-items: center;
  height: 5px;
}

.mine .wrapper .content .wallet .part-3 {
  display: flex;
  align-items: center;
  height: 80px;
}

.mine .wrapper .content .wallet .part-2 .balance {
  flex: 1;
  font-size: 60px;
  color: #fff;
  margin: 0px !important;
  font-weight: 700;
}

/* .mine .wrapper .content .wallet .van-hairline--bottom::after {
  border-bottom-width: 3px;
} */
.mine .wrapper .content .wallet .part-2 .refresh-btn {
  margin-left: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  font-size: 30px;
  border-radius: 50%;
  color: #ffffff;
  background-color: #e6c3a1;
}

.btn {
  margin: 0px;
  padding: 0px 40px;
}
.a-btn {
  display: flex;
  width: 70px;
  height: 70px;
  align-items: center;
  justify-content: center;
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
